module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10056.c9e00f1f.jpg";